<template>
  <div class="login-box">
    <div class="login-logo">
      <img :src="$config.imgDir + '/logo.png'">
    </div>
    <form>
      <div class="login-box-body" style="border-top: 4px solid #3c8dbc;">
        <p class="login-box-msg">Recuperar Senha</p>

        <div class="form-group has-feedback">
          <input type="email"
                 v-model="email"
                 required
                 class="form-control"
                 placeholder="Digite seu e-mail">
          <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
        </div>

        <div class="row">
          <div class="col-xs-4">
            <router-link
              to="/login"
              class="btn btn-sm btn-default">
              <i class="fa fa-arrow-left"></i> Voltar
            </router-link>
          </div>

          <div class="col-xs-8">
            <button type="submit"
                    class="btn btn-sm btn-primary pull-right"
                    :disabled="!email || loading"
                    @click.prevent="submit">
              <i class="fa fa-send"></i>&nbsp; Enviar
            </button>
          </div>
        </div>

        <p v-if="sent" class="text-green" style="margin-top: 15px;">
          Se o e-mail existir, você receberá um link para redefinir sua senha (verifique em sua caixa de entrada).
        </p>

      </div>
    </form>
  </div>
</template>

<script>
import { BackendApi } from '@/services/backend_api'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      email: '',
      loading: false,
      sent: false
    }
  },
  methods: {
    submit () {
      this.loading = true

      BackendApi.getAnonymousClient()
        .put('users/password/recovery', { email: this.email })
        .then(() => {
          this.sent = true
          this.email = ''
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    document.body.className = 'login-page'
  }
}
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?0c3e0dcb